import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Modal,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { db } from "../../firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { showCustomToast } from "../Misc/CustomToast";
import { useAuth } from "../../contexts/AuthContext";

// Simple composant text-area
function TextAreaComponent({ title, value, onChange }) {
  return (
    <div style={{ marginBottom: "1.2rem" }}>
      <div style={{ fontWeight: "500", marginBottom: "0.3rem" }}>{title}</div>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={4}
        style={{ width: "100%" }}
      />
    </div>
  );
}

// Conversion Firestore Timestamp -> Date JS
function convertTimestampToDate(ts) {
  if (!ts || !ts.seconds) return null;
  return new Date(ts.seconds * 1000);
}

// Composant pour afficher deux DatePickers (Due & Completion)
function DatePickersRow({
  label,
  dueDate,
  setDueDate,
  completionDate,
  setCompletionDate,
}) {
  return (
    <div
      style={{
        marginBottom: "1.5rem",
        width: "auto",
      }}
    >
      {label && <div style={{ fontWeight: "bold" }}>{label}</div>}
      <div
        style={{
          display: "flex",
          gap: "1rem",
          marginTop: "0.5rem",
          flexDirection: "column",
        }}
      >
        <div>
          <label>Due Date</label>
          <DatePicker
            selected={dueDate}
            onChange={(date) => setDueDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select"
            // isClearable
          />
        </div>
        <div>
          <label>Completion Date</label>
          <DatePicker
            selected={completionDate}
            onChange={(date) => setCompletionDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select"
            // isClearable
          />
        </div>
      </div>
    </div>
  );
}

// Barre d'entête
function TopTitleFormComponent({ title, closemodal }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1rem",
        backgroundColor: "#1565C0",
        color: "white",
        paddingLeft: "30px",
      }}
    >
      <h2 style={{ margin: 0 }}>{title}</h2>
      {/* <Button variant="contained" onClick={closemodal}>
        Close
      </Button> */}
    </div>
  );
}

function AddTreatmentPlan({ clientId, closemodal, initialData }) {
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  // -- Ajout du champ "Initial Treatment Plan assignments completed"
  //    et "If not, why not ?"
  const [initialAssignmentsCompleted, setInitialAssignmentsCompleted] =
    useState("no");
  const [initialAssignmentsWhyNot, setInitialAssignmentsWhyNot] = useState("");

  // STEP 1
  const [step1Completed, setStep1Completed] = useState("no");

  const [step1Bullet1DueDate, setStep1Bullet1DueDate] = useState(null);
  const [step1Bullet1CompletionDate, setStep1Bullet1CompletionDate] =
    useState(null);

  const [step1Bullet2DueDate, setStep1Bullet2DueDate] = useState(null);
  const [step1Bullet2CompletionDate, setStep1Bullet2CompletionDate] =
    useState(null);

  const [step1Bullet3DueDate, setStep1Bullet3DueDate] = useState(null);
  const [step1Bullet3CompletionDate, setStep1Bullet3CompletionDate] =
    useState(null);

  const [step1Bullet4DueDate, setStep1Bullet4DueDate] = useState(null);
  const [step1Bullet4CompletionDate, setStep1Bullet4CompletionDate] =
    useState(null);

  const [step1Bullet5DueDate, setStep1Bullet5DueDate] = useState(null);
  const [step1Bullet5CompletionDate, setStep1Bullet5CompletionDate] =
    useState(null);

  const [step1Bullet6DueDate, setStep1Bullet6DueDate] = useState(null);
  const [step1Bullet6CompletionDate, setStep1Bullet6CompletionDate] =
    useState(null);

  const [step1Outcome, setStep1Outcome] = useState("");

  // STEP 2
  const [step2Completed, setStep2Completed] = useState("no");

  const [step2Bullet1DueDate, setStep2Bullet1DueDate] = useState(null);
  const [step2Bullet1CompletionDate, setStep2Bullet1CompletionDate] =
    useState(null);

  const [step2Bullet2DueDate, setStep2Bullet2DueDate] = useState(null);
  const [step2Bullet2CompletionDate, setStep2Bullet2CompletionDate] =
    useState(null);

  const [step2Bullet3DueDate, setStep2Bullet3DueDate] = useState(null);
  const [step2Bullet3CompletionDate, setStep2Bullet3CompletionDate] =
    useState(null);

  const [step2Bullet4DueDate, setStep2Bullet4DueDate] = useState(null);
  const [step2Bullet4CompletionDate, setStep2Bullet4CompletionDate] =
    useState(null);

  const [step2Bullet5DueDate, setStep2Bullet5DueDate] = useState(null);
  const [step2Bullet5CompletionDate, setStep2Bullet5CompletionDate] =
    useState(null);

  const [step2Outcome, setStep2Outcome] = useState("");

  // STEP 1 (suite) - manquant
  const [step1Bullet3bisDueDate, setStep1Bullet3bisDueDate] = useState(null);
  const [step1Bullet3bisCompletionDate, setStep1Bullet3bisCompletionDate] =
    useState(null);

  // STEP 2 (suite) - manquant
  const [step2trisBullet5DueDate, setStep2trisBullet5DueDate] = useState(null);
  const [step2trisBullet5CompletionDate, setStep2trisBullet5CompletionDate] =
    useState(null);

  const [step2Bullet5quatrisDueDate, setStep2Bullet5quatrisDueDate] =
    useState(null);
  const [
    step2Bullet5quatrisCompletionDate,
    setStep2Bullet5quatrisCompletionDate,
  ] = useState(null);

  const [step2WorkshopShareCompleted, setStep2WorkshopShareCompleted] =
    useState("no");

  // Pour Step 3 (atelier + chaque bullet + outcome)
  const [step3Completed, setStep3Completed] = useState("no");

  const [step3Bullet1DueDate, setStep3Bullet1DueDate] = useState(null);
  const [step3Bullet1CompletionDate, setStep3Bullet1CompletionDate] =
    useState(null);

  const [step3Bullet2DueDate, setStep3Bullet2DueDate] = useState(null);
  const [step3Bullet2CompletionDate, setStep3Bullet2CompletionDate] =
    useState(null);

  const [step3Bullet3DueDate, setStep3Bullet3DueDate] = useState(null);
  const [step3Bullet3CompletionDate, setStep3Bullet3CompletionDate] =
    useState(null);

  const [step3Bullet4DueDate, setStep3Bullet4DueDate] = useState(null);
  const [step3Bullet4CompletionDate, setStep3Bullet4CompletionDate] =
    useState(null);

  const [step3Bullet5DueDate, setStep3Bullet5DueDate] = useState(null);
  const [step3Bullet5CompletionDate, setStep3Bullet5CompletionDate] =
    useState(null);

  const [step3Bullet6DueDate, setStep3Bullet6DueDate] = useState(null);
  const [step3Bullet6CompletionDate, setStep3Bullet6CompletionDate] =
    useState(null);

  const [step3Bullet7DueDate, setStep3Bullet7DueDate] = useState(null);
  const [step3Bullet7CompletionDate, setStep3Bullet7CompletionDate] =
    useState(null);

  const [step3Bullet8DueDate, setStep3Bullet8DueDate] = useState(null);
  const [step3Bullet8CompletionDate, setStep3Bullet8CompletionDate] =
    useState(null);

  const [step3Bullet9DueDate, setStep3Bullet9DueDate] = useState(null);
  const [step3Bullet9CompletionDate, setStep3Bullet9CompletionDate] =
    useState(null);

  const [step3Outcome, setStep3Outcome] = useState("");

  // Au montage ou si initialData change, on pré-remplit
  useEffect(() => {
    if (!initialData) return;

    // initial assignments
    setInitialAssignmentsCompleted(
      initialData.initialAssignmentsCompleted ?? "no"
    );
    setInitialAssignmentsWhyNot(initialData.initialAssignmentsWhyNot ?? "");

    // Step 1
    setStep1Completed(initialData.step1Completed ?? "no");

    if (initialData.step1Bullet1) {
      setStep1Bullet1DueDate(
        convertTimestampToDate(initialData.step1Bullet1.dueDate)
      );
      setStep1Bullet1CompletionDate(
        convertTimestampToDate(initialData.step1Bullet1.completionDate)
      );
    }
    if (initialData.step1Bullet2) {
      setStep1Bullet2DueDate(
        convertTimestampToDate(initialData.step1Bullet2.dueDate)
      );
      setStep1Bullet2CompletionDate(
        convertTimestampToDate(initialData.step1Bullet2.completionDate)
      );
    }
    if (initialData.step1Bullet3) {
      setStep1Bullet3DueDate(
        convertTimestampToDate(initialData.step1Bullet3.dueDate)
      );
      setStep1Bullet3CompletionDate(
        convertTimestampToDate(initialData.step1Bullet3.completionDate)
      );
    }
    if (initialData.step1Bullet4) {
      setStep1Bullet4DueDate(
        convertTimestampToDate(initialData.step1Bullet4.dueDate)
      );
      setStep1Bullet4CompletionDate(
        convertTimestampToDate(initialData.step1Bullet4.completionDate)
      );
    }
    if (initialData.step1Bullet5) {
      setStep1Bullet5DueDate(
        convertTimestampToDate(initialData.step1Bullet5.dueDate)
      );
      setStep1Bullet5CompletionDate(
        convertTimestampToDate(initialData.step1Bullet5.completionDate)
      );
    }
    if (initialData.step1Bullet6) {
      setStep1Bullet6DueDate(
        convertTimestampToDate(initialData.step1Bullet6.dueDate)
      );
      setStep1Bullet6CompletionDate(
        convertTimestampToDate(initialData.step1Bullet6.completionDate)
      );
    }

    // Step 1 - bullet 3bis
    if (initialData.step1Bullet3bis) {
      setStep1Bullet3bisDueDate(
        convertTimestampToDate(initialData.step1Bullet3bis.dueDate)
      );
      setStep1Bullet3bisCompletionDate(
        convertTimestampToDate(initialData.step1Bullet3bis.completionDate)
      );
    }

    // Step 2 - bullet 5 "tris"
    if (initialData.step2trisBullet5) {
      setStep2trisBullet5DueDate(
        convertTimestampToDate(initialData.step2trisBullet5.dueDate)
      );
      setStep2trisBullet5CompletionDate(
        convertTimestampToDate(initialData.step2trisBullet5.completionDate)
      );
    }

    // Step 2 - bullet 5 "quatris"
    if (initialData.step2Bullet5quatris) {
      setStep2Bullet5quatrisDueDate(
        convertTimestampToDate(initialData.step2Bullet5quatris.dueDate)
      );
      setStep2Bullet5quatrisCompletionDate(
        convertTimestampToDate(initialData.step2Bullet5quatris.completionDate)
      );
    }

    setStep1Outcome(initialData.step1Outcome ?? "");

    // Step 2
    setStep2Completed(initialData.step2Completed ?? "no");

    if (initialData.step2Bullet1) {
      setStep2Bullet1DueDate(
        convertTimestampToDate(initialData.step2Bullet1.dueDate)
      );
      setStep2Bullet1CompletionDate(
        convertTimestampToDate(initialData.step2Bullet1.completionDate)
      );
    }
    if (initialData.step2Bullet2) {
      setStep2Bullet2DueDate(
        convertTimestampToDate(initialData.step2Bullet2.dueDate)
      );
      setStep2Bullet2CompletionDate(
        convertTimestampToDate(initialData.step2Bullet2.completionDate)
      );
    }
    if (initialData.step2Bullet3) {
      setStep2Bullet3DueDate(
        convertTimestampToDate(initialData.step2Bullet3.dueDate)
      );
      setStep2Bullet3CompletionDate(
        convertTimestampToDate(initialData.step2Bullet3.completionDate)
      );
    }
    if (initialData.step2Bullet4) {
      setStep2Bullet4DueDate(
        convertTimestampToDate(initialData.step2Bullet4.dueDate)
      );
      setStep2Bullet4CompletionDate(
        convertTimestampToDate(initialData.step2Bullet4.completionDate)
      );
    }
    if (initialData.step2Bullet5) {
      setStep2Bullet5DueDate(
        convertTimestampToDate(initialData.step2Bullet5.dueDate)
      );
      setStep2Bullet5CompletionDate(
        convertTimestampToDate(initialData.step2Bullet5.completionDate)
      );
    }

    setStep2WorkshopShareCompleted(
      initialData.step2WorkshopShareCompleted ?? "no"
    );

    setStep3Completed(initialData.step3Completed ?? "no");

    setStep2Outcome(initialData.step2Outcome ?? "");

    if (initialData.step3Bullet1) {
      setStep3Bullet1DueDate(
        convertTimestampToDate(initialData.step3Bullet1.dueDate)
      );
      setStep3Bullet1CompletionDate(
        convertTimestampToDate(initialData.step3Bullet1.completionDate)
      );
    }
    if (initialData.step3Bullet2) {
      setStep3Bullet2DueDate(
        convertTimestampToDate(initialData.step3Bullet2.dueDate)
      );
      setStep3Bullet2CompletionDate(
        convertTimestampToDate(initialData.step3Bullet2.completionDate)
      );
    }
    if (initialData.step3Bullet3) {
      setStep3Bullet3DueDate(
        convertTimestampToDate(initialData.step3Bullet3.dueDate)
      );
      setStep3Bullet3CompletionDate(
        convertTimestampToDate(initialData.step3Bullet3.completionDate)
      );
    }
    if (initialData.step3Bullet4) {
      setStep3Bullet4DueDate(
        convertTimestampToDate(initialData.step3Bullet4.dueDate)
      );
      setStep3Bullet4CompletionDate(
        convertTimestampToDate(initialData.step3Bullet4.completionDate)
      );
    }
    if (initialData.step3Bullet5) {
      setStep3Bullet5DueDate(
        convertTimestampToDate(initialData.step3Bullet5.dueDate)
      );
      setStep3Bullet5CompletionDate(
        convertTimestampToDate(initialData.step3Bullet5.completionDate)
      );
    }
    if (initialData.step3Bullet6) {
      setStep3Bullet6DueDate(
        convertTimestampToDate(initialData.step3Bullet6.dueDate)
      );
      setStep3Bullet6CompletionDate(
        convertTimestampToDate(initialData.step3Bullet6.completionDate)
      );
    }
    if (initialData.step3Bullet7) {
      setStep3Bullet7DueDate(
        convertTimestampToDate(initialData.step3Bullet7.dueDate)
      );
      setStep3Bullet7CompletionDate(
        convertTimestampToDate(initialData.step3Bullet7.completionDate)
      );
    }
    if (initialData.step3Bullet8) {
      setStep3Bullet8DueDate(
        convertTimestampToDate(initialData.step3Bullet8.dueDate)
      );
      setStep3Bullet8CompletionDate(
        convertTimestampToDate(initialData.step3Bullet8.completionDate)
      );
    }
    if (initialData.step3Bullet9) {
      setStep3Bullet9DueDate(
        convertTimestampToDate(initialData.step3Bullet9.dueDate)
      );
      setStep3Bullet9CompletionDate(
        convertTimestampToDate(initialData.step3Bullet9.completionDate)
      );
    }

    setStep3Outcome(initialData.step3Outcome ?? "");
  }, [initialData]);

  // ---------------------
  // SAVE FUNCTION
  // ---------------------
  const saveCoreTreatmentPlan = async () => {
    setIsLoading(true);

    try {
      const ref = doc(db, "CoreTreatmentPlans", clientId);

      await setDoc(
        ref,
        {
          createdBy: currentUser?.displayName || "Unknown",
          createdAt: serverTimestamp(),

          // initial assignments
          initialAssignmentsCompleted,
          initialAssignmentsWhyNot,

          // Step 1
          step1Completed,
          step1Bullet1: {
            dueDate: step1Bullet1DueDate,
            completionDate: step1Bullet1CompletionDate,
          },
          step1Bullet2: {
            dueDate: step1Bullet2DueDate,
            completionDate: step1Bullet2CompletionDate,
          },
          step1Bullet3: {
            dueDate: step1Bullet3DueDate,
            completionDate: step1Bullet3CompletionDate,
          },
          step1Bullet4: {
            dueDate: step1Bullet4DueDate,
            completionDate: step1Bullet4CompletionDate,
          },
          step1Bullet5: {
            dueDate: step1Bullet5DueDate,
            completionDate: step1Bullet5CompletionDate,
          },
          step1Bullet6: {
            dueDate: step1Bullet6DueDate,
            completionDate: step1Bullet6CompletionDate,
          },
          step1Outcome,

          // Step 2
          step2Completed,
          step2Bullet1: {
            dueDate: step2Bullet1DueDate,
            completionDate: step2Bullet1CompletionDate,
          },
          step2Bullet2: {
            dueDate: step2Bullet2DueDate,
            completionDate: step2Bullet2CompletionDate,
          },
          step2Bullet3: {
            dueDate: step2Bullet3DueDate,
            completionDate: step2Bullet3CompletionDate,
          },
          step2Bullet4: {
            dueDate: step2Bullet4DueDate,
            completionDate: step2Bullet4CompletionDate,
          },
          step2Bullet5: {
            dueDate: step2Bullet5DueDate,
            completionDate: step2Bullet5CompletionDate,
          },

          step1Bullet3bis: {
            dueDate: step1Bullet3bisDueDate,
            completionDate: step1Bullet3bisCompletionDate,
          },

          // Step 2 - bullet 5 "tris"
          step2trisBullet5: {
            dueDate: step2trisBullet5DueDate,
            completionDate: step2trisBullet5CompletionDate,
          },

          // Step 2 - bullet 5 "quatris"
          step2Bullet5quatris: {
            dueDate: step2Bullet5quatrisDueDate,
            completionDate: step2Bullet5quatrisCompletionDate,
          },

          step2Outcome,

          step2WorkshopShareCompleted,

          step3Completed,
          step3Bullet1: {
            dueDate: step3Bullet1DueDate,
            completionDate: step3Bullet1CompletionDate,
          },
          step3Bullet2: {
            dueDate: step3Bullet2DueDate,
            completionDate: step3Bullet2CompletionDate,
          },
          step3Bullet3: {
            dueDate: step3Bullet3DueDate,
            completionDate: step3Bullet3CompletionDate,
          },
          step3Bullet4: {
            dueDate: step3Bullet4DueDate,
            completionDate: step3Bullet4CompletionDate,
          },
          step3Bullet5: {
            dueDate: step3Bullet5DueDate,
            completionDate: step3Bullet5CompletionDate,
          },
          step3Bullet6: {
            dueDate: step3Bullet6DueDate,
            completionDate: step3Bullet6CompletionDate,
          },
          step3Bullet7: {
            dueDate: step3Bullet7DueDate,
            completionDate: step3Bullet7CompletionDate,
          },
          step3Bullet8: {
            dueDate: step3Bullet8DueDate,
            completionDate: step3Bullet8CompletionDate,
          },
          step3Bullet9: {
            dueDate: step3Bullet9DueDate,
            completionDate: step3Bullet9CompletionDate,
          },
          step3Outcome,
        },
        { merge: true }
      );

      showCustomToast("Core Treatment Plan successfully saved!", "success");
      closemodal();
    } catch (error) {
      console.error("Error saving Core Treatment Plan: ", error);
      showCustomToast("Error saving plan. Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------------
  // MODAL STYLE
  // ---------------------
  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "85%",
    height: "85%",
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  };
  const printRef = useRef(null);

  const handlePrint = () => {
    const content = printRef.current?.innerHTML;
    if (!content) return;
    const w = window.open("", "_blank", "width=1200,height=900");
    if (!w) return;
    w.document.write(`
      <!doctype html>
      <html>
        <head>
          <title>Core Treatment Plan</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 16px; }
            .print-section { max-width: 1100px; margin: 0 auto; }
            h2, h3 { margin: 12px 0; }
            div { box-sizing: border-box; }
            input, select, textarea { font-size: 12px; padding: 4px 6px; max-width: 220px; width: 100%; box-sizing: border-box; }
            textarea { width: 100%; }
            input[type="radio"] { width: 14px; height: 14px; transform: scale(0.9); }
            .print-section * { max-width: 100%; }
            label { font-size: 13px; }
            @media print {
              input[type="radio"],
              .MuiRadio-root,
              .MuiSvgIcon-root,
              .MuiFormControlLabel-root,
              label.MuiFormControlLabel-label { display: none !important; visibility: hidden !important; height: 0 !important; width: 0 !important; }
              .print-radio-value { display: inline !important; font-weight: 600; margin-left: 6px; }
            }
            @media screen {
              .print-radio-value { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="print-section">
            ${content}
          </div>
        </body>
      </html>
    `);
    w.document.close();
    w.focus();
    w.print();
    setTimeout(() => w.close(), 200);
  };

  return (
    <Modal
      open={true}
      onClose={closemodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styleModalGeneral}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden",
          }}
        >
          <TopTitleFormComponent
            title="Core Treatment Plan"
            closemodal={closemodal}
          />

          <div
            ref={printRef}
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "1rem",
              paddingLeft: "30px",
              paddingRight: "16px",
            }}
          >
          {/* PARTIE "Initial Treatment Plan assignments completed" */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                paddingBottom: "10px",
              }}
            >
              <div style={{ fontSize: "18px", fontWeight: "500" }}>
                Initial Treatment Plan assignments completed?
              </div>
              <div style={{ paddingLeft: "25px" }}>
                <RadioGroup
                  row
                  value={initialAssignmentsCompleted}
                  onChange={(e) => setInitialAssignmentsCompleted(e.target.value)}
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                <div className="print-radio-value">
                  {initialAssignmentsCompleted === "yes" ? "Yes" : "No"}
                </div>
              </div>
            </div>

          {initialAssignmentsCompleted === "no" && (
            <TextAreaComponent
              title="If not, why not?"
              value={initialAssignmentsWhyNot}
              onChange={setInitialAssignmentsWhyNot}
            />
          )}

          {/* ------------------------------------- */}
          {/* STEP 1 */}
          {/* ------------------------------------- */}
          <div
            style={{
              fontSize: "20px",
              fontWeight: "700",
              paddingBottom: "10px",
            }}
          >
            Acceptance
          </div>

          <div style={{ fontSize: "16px" }}>
            The process of accepting your powerlessness over your addiction is
            crucial for maintaining abstinent recovery. The following
            assignments are designed to support you in the process of admitting
            and accepting your powerlessness related to your addiction. To do
            this, you write about the evidence that illustrates your own
            personal powerlessness and unmanageability in your life.
          </div>

          <h2>Complete Step 1</h2>

          <div style={{ width: "70%" }}>
            {/* Radio pour "Attend Step 1 workshop" */}
            <div
              style={{
                marginBottom: "1rem",
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <FormLabel>Attend Step 1 Workshop Completed?</FormLabel>
              <div style={{ paddingLeft: "10px" }}>
                <RadioGroup
                  row
                  value={step1Completed}
                  onChange={(e) => setStep1Completed(e.target.value)}
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                <div className="print-radio-value">
                  {step1Completed === "yes" ? "Yes" : "No"}
                </div>
              </div>
            </div>

            {/* Bullet 1 */}
            <div style={{ fontWeight: "bold", fontSize: "18px" }}>
              Mandatory Questions
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                How would you describe denial to someone that does not
                understand addiction?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step1Bullet1DueDate}
                  setDueDate={setStep1Bullet1DueDate}
                  completionDate={step1Bullet1CompletionDate}
                  setCompletionDate={setStep1Bullet1CompletionDate}
                />
              </div>
            </div>

            {/* Bullet 2 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Complete a mind map on Denial. Include aspects of rationalising,
                justifying, minimalizing, and blaming. Share in therapy group.
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step1Bullet2DueDate}
                  setDueDate={setStep1Bullet2DueDate}
                  completionDate={step1Bullet2CompletionDate}
                  setCompletionDate={setStep1Bullet2CompletionDate}
                />
              </div>
            </div>

            <div style={{ fontWeight: "bold", fontSize: "18px" }}>
              Choose 1 to answer
            </div>

            {/* Bullet 3 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Describe times in your addiction where you have experienced
                desperation to stop using. Include any unsuccess attempts to
                quit and how these impacted you. Share in therapy group.
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step1Bullet3DueDate}
                  setDueDate={setStep1Bullet3DueDate}
                  completionDate={step1Bullet3CompletionDate}
                  setCompletionDate={setStep1Bullet3CompletionDate}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Identify and describe times during your addiction where you have
                lost control over your substance use and highlight the
                consequences of losing control. Share examples in group therapy
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step1Bullet3bisDueDate}
                  setDueDate={setStep1Bullet3bisDueDate}
                  completionDate={step1Bullet3bisCompletionDate}
                  setCompletionDate={setStep1Bullet3bisCompletionDate}
                />
              </div>
            </div>

            {/* Bullet 4 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Describe crisis events that supported you in recognising that
                your addiction was a problem and needing to stop.
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step1Bullet4DueDate}
                  setDueDate={setStep1Bullet4DueDate}
                  completionDate={step1Bullet4CompletionDate}
                  setCompletionDate={setStep1Bullet4CompletionDate}
                />
              </div>
            </div>

            {/* Bullet 5 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Complete a reflective exercise describing what you have learned
                from completing each of the Step 1 assignments. Also write about
                your strengths that supported you to get through all of these
                experiences.
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step1Bullet5DueDate}
                  setDueDate={setStep1Bullet5DueDate}
                  completionDate={step1Bullet5CompletionDate}
                  setCompletionDate={setStep1Bullet5CompletionDate}
                />
              </div>
            </div>

            {/* Bullet 6 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Explore with your therapist and process group any areas of
                concern you notice that you want to work on as part of your
                treatment plan.
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step1Bullet6DueDate}
                  setDueDate={setStep1Bullet6DueDate}
                  completionDate={step1Bullet6CompletionDate}
                  setCompletionDate={setStep1Bullet6CompletionDate}
                />
              </div>
            </div>
          </div>

          <div style={{ width: "70%", paddingTop: "20px" }}>
            <TextAreaComponent
              title="Outcome from Step 1 assignments:"
              value={step1Outcome}
              onChange={setStep1Outcome}
            />
          </div>

          {/* ------------------------------------- */}
          {/* STEP 2 */}
          {/* ------------------------------------- */}
          <h2>Complete Step 2</h2>

          {/* Radio pour "Attend Step 2 workshop" */}
          <div
            style={{
              marginBottom: "1rem",
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <FormLabel>Attend Step 2 Workshop Completed?</FormLabel>
            <div style={{ paddingLeft: "10px" }}>
              <RadioGroup
                row
                value={step2Completed}
                onChange={(e) => setStep2Completed(e.target.value)}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
              <div className="print-radio-value">
                {step2Completed === "yes" ? "Yes" : "No"}
              </div>
            </div>
          </div>

          {/* Bullet 1 */}

          <div
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              paddingBottom: "10px",
            }}
          >
            Mandatory Questions
          </div>

          <div style={{ width: "70%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Describe what you understand by the term power greater than
                myself.
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step2Bullet1DueDate}
                  setDueDate={setStep2Bullet1DueDate}
                  completionDate={step2Bullet1CompletionDate}
                  setCompletionDate={setStep2Bullet1CompletionDate}
                />
              </div>
            </div>

            {/* Bullet 2 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                How would you describe ‘a power greater than yourself to someone
                that does not understand addiction or recovery?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step2Bullet2DueDate}
                  setDueDate={setStep2Bullet2DueDate}
                  completionDate={step2Bullet2CompletionDate}
                  setCompletionDate={setStep2Bullet2CompletionDate}
                />
              </div>
            </div>

            <div
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                paddingBottom: "10px",
              }}
            >
              Choose 1 to answer
            </div>

            {/* Bullet 3 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                How does it feel when you think about surrendering control of
                the things you cannot control?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step2Bullet3DueDate}
                  setDueDate={setStep2Bullet3DueDate}
                  completionDate={step2Bullet3CompletionDate}
                  setCompletionDate={setStep2Bullet3CompletionDate}
                />
              </div>
            </div>

            {/* Bullet 4 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Who or what has inspired you in times of struggle? And why?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step2Bullet4DueDate}
                  setDueDate={setStep2Bullet4DueDate}
                  completionDate={step2Bullet4CompletionDate}
                  setCompletionDate={setStep2Bullet4CompletionDate}
                />
              </div>
            </div>

            {/* Bullet 5 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                What would you like to take from these experiences that you can
                carry forwards into your recovery?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step2trisBullet5DueDate}
                  setDueDate={setStep2trisBullet5DueDate}
                  completionDate={step2trisBullet5CompletionDate}
                  setCompletionDate={setStep2Bullet5CompletionDate}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Reflect on your time in Miracles, and describe your concept of a
                power greater than yourself as it is now and how it may have
                developed. Identify how this may support you in your recovery.
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step2Bullet5quatrisDueDate}
                  setDueDate={setStep2Bullet5quatrisDueDate}
                  completionDate={step2Bullet5quatrisCompletionDate}
                  setCompletionDate={setStep2Bullet5quatrisCompletionDate}
                />
              </div>
            </div>
          </div>

          <div
            style={{
              marginBottom: "1rem",
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
              paddingTop: "20px",
            }}
          >
            <FormLabel>
              Share assignments in the Step 2 workshop Completed?
            </FormLabel>
            <div style={{ paddingLeft: "10px" }}>
              <RadioGroup
                row
                value={step2WorkshopShareCompleted}
                onChange={(e) => setStep2WorkshopShareCompleted(e.target.value)}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
              <div className="print-radio-value">
                {step2WorkshopShareCompleted === "yes" ? "Yes" : "No"}
              </div>
            </div>
          </div>

          <div style={{ width: "70%", paddingTop: "20px" }}>
            <TextAreaComponent
              title="Outcome from Step 2 assignments:"
              value={step2Outcome}
              onChange={setStep2Outcome}
            />
          </div>

          <h2>Complete Step 3</h2>

          {/* Radio pour "Attend Step 3 workshop Completed?" */}
          <div
            style={{
              marginBottom: "1rem",
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <FormLabel>Attend Step 3 Workshop Completed?</FormLabel>
            <div style={{ paddingLeft: "10px" }}>
              <RadioGroup
                row
                value={step3Completed}
                onChange={(e) => setStep3Completed(e.target.value)}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
              <div className="print-radio-value">
                {step3Completed === "yes" ? "Yes" : "No"}
              </div>
            </div>
          </div>

          {/* BULLET 1 */}
          <div
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              paddingBottom: "20px",
            }}
          >
            Mandatory Questions
          </div>

          <div style={{ width: "70%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Describe experiences in your life when you’ve recognised the
                need to change and successfully changed.
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step3Bullet1DueDate}
                  setDueDate={setStep3Bullet1DueDate}
                  completionDate={step3Bullet1CompletionDate}
                  setCompletionDate={setStep3Bullet1CompletionDate}
                />
              </div>
            </div>

            {/* BULLET 2 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Describe times in your life where you recognised the needs to
                change but felt blocked from making those changes? What did that
                feel like?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step3Bullet2DueDate}
                  setDueDate={setStep3Bullet2DueDate}
                  completionDate={step3Bullet2CompletionDate}
                  setCompletionDate={setStep3Bullet2CompletionDate}
                />
              </div>
            </div>

            {/* BULLET 3 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Describe how your life may be different if you were able to make
                the previous changes that you needed to make.
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step3Bullet3DueDate}
                  setDueDate={setStep3Bullet3DueDate}
                  completionDate={step3Bullet3CompletionDate}
                  setCompletionDate={setStep3Bullet3CompletionDate}
                />
              </div>
            </div>

            <div
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                paddingBottom: "20px",
              }}
            >
              Choose 1 to answer
            </div>

            {/* BULLET 4 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                What does turning your will and your life over mean to you
                personally?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step3Bullet4DueDate}
                  setDueDate={setStep3Bullet4DueDate}
                  completionDate={step3Bullet4CompletionDate}
                  setCompletionDate={setStep3Bullet4CompletionDate}
                />
              </div>
            </div>

            {/* BULLET 5 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                How do you feel about trusting in something at this point in
                your recovery?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step3Bullet5DueDate}
                  setDueDate={setStep3Bullet5DueDate}
                  completionDate={step3Bullet5CompletionDate}
                  setCompletionDate={setStep3Bullet5CompletionDate}
                />
              </div>
            </div>

            {/* BULLET 6 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                What evidence can you find in your life that suggests you are
                ready to make the changes needed?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step3Bullet6DueDate}
                  setDueDate={setStep3Bullet6DueDate}
                  completionDate={step3Bullet6CompletionDate}
                  setCompletionDate={setStep3Bullet6CompletionDate}
                />
              </div>
            </div>

            {/* BULLET 7 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                Can you recognise any opportunities in treatment where you have
                or can trust in something beyond yourself to support your
                recovery? What have you learned from those experiences?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step3Bullet7DueDate}
                  setDueDate={setStep3Bullet7DueDate}
                  completionDate={step3Bullet7CompletionDate}
                  setCompletionDate={setStep3Bullet7CompletionDate}
                />
              </div>
            </div>

            {/* BULLET 8 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                If you were to fully embrace this step, what changes might you
                notice in your thoughts, feelings, and behaviour?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step3Bullet8DueDate}
                  setDueDate={setStep3Bullet8DueDate}
                  completionDate={step3Bullet8CompletionDate}
                  setCompletionDate={setStep3Bullet8CompletionDate}
                />
              </div>
            </div>

            {/* BULLET 9 */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                border: "1px solid lightgrey",
                paddingLeft: "10px",
                borderRadius: "10px",
                paddingTop: "10px",
                width: "auto",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  width: "70%",
                  paddingRight: "20px",
                }}
              >
                How can taking steps to develop trust in something beyond
                yourself support you in achieving the goals you have set for
                your recovery?
              </div>
              <div style={{ width: "30%" }}>
                <DatePickersRow
                  dueDate={step3Bullet9DueDate}
                  setDueDate={setStep3Bullet9DueDate}
                  completionDate={step3Bullet9CompletionDate}
                  setCompletionDate={setStep3Bullet9CompletionDate}
                />
              </div>
            </div>

            {/* Outcome Step 3 */}
            <div style={{ width: "70%", paddingTop: "20px" }}>
              <TextAreaComponent
                title="Outcome from Step 3 assignments:"
                value={step3Outcome}
                onChange={setStep3Outcome}
              />
            </div>
          </div>

          {/* ------------------------- */}
          {/* BUTTONS SAVE / CANCEL */}
          {/* ------------------------- */}
          </div>
          <div
            style={{
              marginTop: "0.5rem",
              padding: "1rem 30px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "1rem",
              position: "sticky",
              bottom: 0,
              backgroundColor: "white",
              borderTop: "1px solid #e0e0e0",
            }}
          >
            <Button
              variant="outlined"
              onClick={handlePrint}
              style={{ backgroundColor: "white", color: "black" }}
            >
              Print
            </Button>
            <Button
              variant="contained"
              onClick={closemodal}
              style={{ backgroundColor: "white", color: "black" }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={saveCoreTreatmentPlan}
              disabled={isLoading}
              style={
                isLoading
                  ? { backgroundColor: "red", color: "white" }
                  : { backgroundColor: "#1565C0", color: "white" }
              }
            >
              {isLoading ? "Saving..." : "Save Core Treatment Plan"}
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default AddTreatmentPlan;
